/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SaveDataFourthStageRequest
 */
export interface SaveDataFourthStageRequest {
  /**
   * Id выбранных продуктов
   * @type {Array<number>}
   * @memberof SaveDataFourthStageRequest
   */
  productList: Array<number>
}

/**
 * Check if a given object implements the SaveDataFourthStageRequest interface.
 */
export function instanceOfSaveDataFourthStageRequest(
  value: object
): value is SaveDataFourthStageRequest {
  if (!('productList' in value) || value['productList'] === undefined)
    return false
  return true
}

export function SaveDataFourthStageRequestFromJSON(
  json: any
): SaveDataFourthStageRequest {
  return SaveDataFourthStageRequestFromJSONTyped(json, false)
}

export function SaveDataFourthStageRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveDataFourthStageRequest {
  if (json == null) {
    return json
  }
  return {
    productList: json['productList'],
  }
}

export function SaveDataFourthStageRequestToJSON(
  value?: SaveDataFourthStageRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    productList: value['productList'],
  }
}
